import React from "react";
import { FilterBar, Menu, SearchBar, Select } from "@sscs/ui";
import {
  GROUP_ROLES,
  GROUP_ROLE_DETAILS,
  ORG_ROLES,
  ORG_ROLE_DETAILS,
} from "Constants";
import { useDialog, useLoginInfo } from "Hooks";
import { FilterMembers } from "../../types";
import ActionBarButton from "./ActionBarButton";

type MembersTableActionBarProps = {
  filter: FilterMembers;
  groupId?: string;
  onFilterChange: (filter: FilterMembers) => void;
};

const MembersTableActionBar = ({
  filter,
  groupId,
  onFilterChange,
}: MembersTableActionBarProps): React.JSX.Element => {
  const inviteMemberToOrgDialog = useDialog();
  const { isSSOLogin } = useLoginInfo();
  const roles = groupId ? GROUP_ROLES : ORG_ROLES;
  const roleDetails = groupId ? GROUP_ROLE_DETAILS : ORG_ROLE_DETAILS;

  return (
    <FilterBar
      filters={[
        {
          id: "email",
          control: (
            <SearchBar
              id={`members-filter-email-${groupId ?? ""}`}
              value={filter.email ?? ""}
              onChange={(value) => onFilterChange({ ...filter, email: value })}
              variant="outlined"
              label="Search for email"
              slotProps={{ htmlInput: { maxLength: 256 } }}
              debounceTimer={250}
              isFullWidth={false}
            />
          ),
        },
        {
          id: "role",
          width: "150px",
          control: (
            <Select
              id={`filter-role-${groupId ?? ""}`}
              value={filter.role || "ALL"}
              onChange={(value) => onFilterChange({ ...filter, role: value })}
              variant="outlined"
            >
              <Menu.Item id="filter-role-all" value="ALL">
                All roles
              </Menu.Item>
              {roles.map((role) => (
                <Menu.Item
                  key={`filter-role-${role}`}
                  id={`filter-role-${role}`}
                  value={role}
                >
                  {roleDetails[role]?.shortLabel}
                </Menu.Item>
              ))}
            </Select>
          ),
        },
        {
          id: "invite",
          fit: true,
          hidden: Boolean(groupId) || isSSOLogin,
          control: (
            <ActionBarButton
              openInviteMemberToOrg={inviteMemberToOrgDialog.open}
              closeInviteMemberToOrg={inviteMemberToOrgDialog.close}
              inviteMemberToOrgOpen={inviteMemberToOrgDialog.isOpen}
            />
          ),
        },
      ]}
    />
  );
};

export default MembersTableActionBar;
